function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 0,
  y: 0,
  width: 80,
  height: 60,
  rx: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M35.724,16.6008 C32.7497,14.913 29,16.9816 29,20.3102 L29,39.6898 C29,43.0183 32.7494,45.0869 35.7237,43.3993 L52.8004,33.7105 C55.733,32.0466 55.7332,27.9558 52.8007,26.2916 L35.724,16.6008 Z"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA4MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCBmaWxsPSJjdXJyZW50Q29sb3IiIHg9IjAiIHk9IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSI2MCIgcng9IjQiIC8+CiAgPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTM1LjcyNCwxNi42MDA4IEMzMi43NDk3LDE0LjkxMyAyOSwxNi45ODE2IDI5LDIwLjMxMDIgTDI5LDM5LjY4OTggQzI5LDQzLjAxODMgMzIuNzQ5NCw0NS4wODY5IDM1LjcyMzcsNDMuMzk5MyBMNTIuODAwNCwzMy43MTA1IEM1NS43MzMsMzIuMDQ2NiA1NS43MzMyLDI3Ljk1NTggNTIuODAwNywyNi4yOTE2IEwzNS43MjQsMTYuNjAwOCBaIiAvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };